/**
 * DUEL Design Tokens — 90s Raw League Aesthetic
 * 
 * Matches the douevenlift.com website exactly.
 * Use these tokens alongside theme.colors for consistent styling.
 * 
 * Philosophy: Iron. Chalk. Rubber mats. 
 * Sharp edges (borderRadius: 2-4), heavy type, industrial feel.
 * Early UFC programs, old Gold's Gym posters, WWF attitude era.
 */

/** Spacing scale */
export const SPACE = {
  xs: 4,
  sm: 8,
  base: 12,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48,
  '3xl': 64,
} as const;

/** Font size scale */
export const FONT = {
  xs: 11,
  sm: 12,
  base: 14,
  md: 16,
  lg: 18,
  xl: 22,
  '2xl': 28,
  '3xl': 36,
  '4xl': 48,
} as const;

/** Letter spacing — website uses wide tracking on labels */
export const TRACKING = {
  tight: 0.5,
  normal: 1,
  wide: 2,
  wider: 3,
  widest: 5,
} as const;

/** Border radius — sharp, industrial. No rounded pills. */
export const RADIUS = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 6,
  /** Max radius used in the app — still angular */
  lg: 8,
} as const;

/** Card styling presets */
export const CARD = {
  /** Standard card: dark surface, thin border, sharp corners */
  standard: {
    borderRadius: 2,
    borderWidth: 1,
    padding: 24,
  },
  /** Compact card for list items */
  compact: {
    borderRadius: 2,
    borderWidth: 1,
    padding: 20,
  },
} as const;

/** Button styling presets */
export const BUTTON = {
  primary: {
    borderRadius: 0,
    paddingVertical: 14,
    paddingHorizontal: 32,
  },
  secondary: {
    borderRadius: 0,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderWidth: 1,
  },
} as const;

/** Scar line — the signature horizontal accent from the website */
export const SCAR = {
  height: 1,
  /** Gold accent width as percentage of container */
  accentWidth: '20%',
} as const;

/** Section label style — "BARLOW CONDENSED · UPPERCASE · GOLD · WIDE TRACKING" */
export const SECTION_LABEL = {
  fontSize: 12,
  letterSpacing: 5,
  textTransform: 'uppercase' as const,
};

/** Minimum touch target — 44x44px per Apple/Google HIG */
export const TOUCH_TARGET = {
  minHeight: 44,
  minWidth: 44,
} as const;

/** Section title style — "OSWALD · UPPERCASE · BRIGHT" */
export const SECTION_TITLE = {
  fontSize: 28,
  letterSpacing: 2,
  textTransform: 'uppercase' as const,
  lineHeight: 32,
};
